import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//解决vue路由重复导航错误
//获取原型对象上的push函数

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: {
      title: '首页',
      navId: 1,
    }
  },
  {
    path: '/club',
    name: 'club',
    component: () => import('../views/game/club.vue'),
    meta: {
      title: '俱乐部',
      navId: 1,
    }
  },
  {
    path: '/eventActivities',
    name: 'eventActivities',
    component: () => import('../views/game/eventActivities.vue'),
    meta: {
      title: '赛事活动',
      navId: 5,
    }
  },
  {
    path: '/eventDetails',
    name: 'eventDetails',
    component: () => import('../views/game/eventDetails.vue'),
    meta: {
      title: '赛事详情',
      navId: 5,
    }
  },
  {
    path: '/eventRegistration',
    name: 'eventRegistration',
    component: () => import('../views/game/eventRegistration.vue'),
    meta: {
      title: '赛事报名',
      navId: 5,
    }
  },
  {
    path: '/venueReservation',
    name: 'venueReservation',
    component: () => import('../views/venue/venueReservation.vue'),
    meta: {
      title: '场馆预定',
      navId: 4,
    }
  },
  {
    path: '/venueDetail',
    name: 'venueDetail',
    component: () => import('../views/venue/venueDetail.vue'),
    meta: {
      title: '场馆详情',
      navId: 4,
    }
  },
  {
    path: '/sportsInformation',
    name: 'sportsInformation',
    component: () => import('../views/sportsInformation/sportsInformation.vue'),
    meta: {
      title: '体育资讯',
      navId: 2,
    }
  },
  {
    path: '/sportsDetails',
    name: 'sportsDetails',
    component: () => import('../views/sportsInformation/sportsDetails.vue'),
    meta: {
      title: '体育详情',
      navId: 2,
    }
  },
  {
    path: '/fitnessMap',
    name: 'fitnessMap',
    component: () => import('../views/fitnessMap.vue'),
    meta: {
      title: '健身地图',
      navId: 3,
    }
  },
  {
    path: '/fitnessLearningCourses',
    name: 'fitnessLearningCourses',
    component: () => import('../views/fitnessLearningCourses/fitnessLearningCourses.vue'),
    meta: {
      title: '健身学习课程',
      navId: 4,
    }
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import('../views/fitnessLearningCourses/courseDetail.vue'),
    meta: {
      title: '健身学习课程详情',
      navId: 4,
    }
  },
  {
    path: '/instructorIndex',
    name: 'instructorIndex',
    component: () => import('../views/anInstructor/instructorIndex.vue'),
    meta: {
      title: '社会体育指导员',
      navId: 5,
    }
  },
  {
    path: '/instructorDetails',
    name: 'instructorDetails',
    component: () => import('../views/anInstructor/instructorDetails.vue'),
    meta: {
      title: '社会体育指导员详情',
      navId: 5,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {
      title: '登录',
      navId: 6,
    }
  },
  {
    path: '/mineCenter',
    redirect:'/mineCenter/mineData',
    name: 'mineCenter',
    component: () => import('../views/mineCenter/index.vue'),
    meta: {
      title: '个人中心',
      navId: 0,
    },
    children:[
      {
        path: '/mineCenter/mineData',
        name: 'mineCenter_mineData',
        component: () => import('../views/mineCenter/mineData/index'),
        meta: {
          title: '个人信息',
          navId: 7,
        }
      },
      {
        path: '/mineCenter/MineOrderForGoods',
        redirect:'/mineCenter/MineOrderForGoods/VenueOrders',
        name: 'mineCenter_MineOrderForGoods',
        component: () => import('../views/mineCenter/MineOrderForGoods/index'),
        meta: {
          title: '我的订单',
          navId: 7,
        },
        children:[
          {
            path: '/mineCenter/MineOrderForGoods/VenueOrders',
            name: 'mineCenter_MineOrderForGoods_VenueOrders',
            component: () => import('../views/mineCenter/MineOrderForGoods/VenueOrders'),
            meta: {
              title: '场馆订单',
              navId: 7,
            }
          },
          {
            path: '/mineCenter/MineOrderForGoods/eventOrders',
            name: 'mineCenter_MineOrderForGoods_eventOrders',
            component: () => import('../views/mineCenter/MineOrderForGoods/eventOrders'),
            meta: {
              title: '赛事订单',
              navId: 7,
            }
          },
        ]
      },

      {
        path: '/mineCenter/accountSecurity',
        name: 'mineCenter_accountSecurity',
        component: () => import('../views/mineCenter/accountSecurity/index'),
        meta: {
          title: '账号安全',
          navId: 7,
        }
      },
    ]
  },
  {
    path: '/mineData/aboutUs',
    name: 'mineData_aboutUs',
    component: () => import('../views/mineCenter/mineData/aboutUs'),
    meta: {
      title: '关于我们',
      navId: 0,
    }
  },
  {
    path: '/mineData/termService',
    name: 'mineData_termService',
    component: () => import('../views/mineCenter/mineData/termService'),
    meta: {
      title: '服务条款',
      navId: 0,
    }
  },
  {
    path: '/eventMap',
    name: 'eventMap',
    component: () => import('../views/eventMap'),
    meta: {
      title: '赛事地图',
      navId: 7,
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
});

export default router
